import { RadioButton } from "@habitech/selectors"
import {
    FormGroup,
    Grid,
    Label,
    RadioGroup,
    RadioLabel,
    Section
} from "../FormElement/styles"
import { ButtonGroup } from "../../styles"
import { Button as ButtonKeychain } from "@habitech/call-to-action"
import { TextField } from "@habitech/keychain-atoms-inputs"
import { useContext } from "react"
import { NotificationsContext } from "../../context/NotificationContext"
import { TabBarContext } from "src/components/common/TabSwich";
import { GridContainer, GridItem } from "src/components/common/grids";

export const ContentComponent = () => {
    const {
        dataForm,
        errors,
        blur,
        isValid,
        handleChange,
    } = useContext(NotificationsContext)
    const { setTab } = useContext(TabBarContext);

    const handleContinue = () => {
        setTab('tab-2')
    }

    return <Section>

        <GridContainer>
            <GridItem lg={12}>
                <FormGroup>
                    <Label htmlFor="notificationType">Tipo de notificación</Label>
                    <RadioGroup>
                        <RadioLabel>
                            <RadioButton
                                originType="pcom"
                                dataId="notificationType-normal"
                                id="notificationType"
                                name="notificationType"
                                type="default"
                                value="normal"
                                selected={dataForm.notificationType}
                                onChange={handleChange.bind(null, 'notificationType', "normal")}
                            />
                            Normal
                        </RadioLabel>
                        <RadioLabel>
                            <RadioButton
                                dataId="notificationType-destacada"
                                id="notificationType"
                                name="notificationType"
                                originType="pcom"
                                value="destacada"
                                selected={dataForm.notificationType}
                                onChange={handleChange.bind(null, 'notificationType', "destacada")}
                            />
                            Destacada
                        </RadioLabel>
                    </RadioGroup>
                </FormGroup>
            </GridItem>
            <GridItem lg={6}>
                <FormGroup>
                    <Label htmlFor="title">Título</Label>
                    <TextField
                        dataId='title'
                        name='title'
                        id="title"
                        type="text"
                        value={dataForm.title}
                        onChange={handleChange.bind(null)}
                        placeHolder="Ingresa el título"
                        originType='pcom'
                        error={!!errors["title"] && blur["title"]?.length >= 0}
                        errorMessage={errors["title"]}
                    />
                </FormGroup>
            </GridItem>

            <GridItem lg={6}>
                <FormGroup>
                    <Label htmlFor="description">Descripción</Label>
                    <TextField
                        dataId='description'
                        type="text"
                        id="description"
                        name='description'
                        value={dataForm.description}
                        onChange={handleChange}
                        placeHolder="Ingresa la descripción"
                        originType='pcom'
                        error={!!errors["description"] && blur["description"]?.length >= 0}
                        errorMessage={errors["description"]}
                    />
                </FormGroup>
            </GridItem>

        </GridContainer>


        <Grid>
           {dataForm.notificationType === "destacada" && <FormGroup>
                <Label htmlFor="ctaText">Texto del CTA</Label>
                <TextField
                    dataId='ctaText'
                    name='ctaText'
                    id="ctaText"
                    type="text"
                    value={dataForm.ctaText}
                    onChange={handleChange.bind(null)}
                    placeHolder="Ej: Ver más, Comprar ahora"
                    originType='pcom'
                    error={!!errors['ctaText'] && blur["ctaText"]?.length >= 0}
                    errorMessage={errors['ctaText']}
                />
            </FormGroup>}

            <FormGroup>
                <Label htmlFor="ctaLink">Enlace del CTA</Label>
                <TextField
                    dataId='ctaLink'
                    name='ctaLink'
                    id="ctaLink"
                    type="text"
                    value={dataForm.ctaLink}
                    onChange={handleChange.bind(null)}
                    placeHolder="https://ejemplo.com/pagina"
                    originType='pcom'
                    error={!!errors['ctaLink'] && blur["ctaLink"]?.length >= 0}
                    errorMessage={errors['ctaLink']}
                    maxLength={3000}
                />
            </FormGroup>
        </Grid>
        <ButtonGroup>
            <ButtonKeychain dataId='continue' originType='pcom' onClick={handleContinue} disabled={!isValid}>Asignar audiencia</ButtonKeychain>
        </ButtonGroup>
    </Section>
}